import { Component, signal } from '@angular/core';
import { BackgroundComponent } from '../../../shared/pages/background/background.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-update-password',
  imports: [
    RouterLink,
    BackgroundComponent
  ],
  templateUrl: './update-password.component.html',
  styles: [],
})
export class UpdatePasswordComponent {
  public showPasswordTemp = signal(false);
  public showPasswordNew = signal(false);

  togglePasswordVisibility(field: 'temp' | 'new') {
    const signals = {
      temp: this.showPasswordTemp,
      new: this.showPasswordNew
    };

    signals[field].update(value => !value);
  }
}
